export class SugerenciasModel {

  id: number;
  descripcion: string;

  constructor() {
    this.descripcion = '';
  }
}
